import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { usePDF } from "@react-pdf/renderer";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";

import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";

import InstructionPage from "./InstructionPage";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import AppContext from "../../appContext";
import useAccountSettings from "../../ManageAccount/useAccountSettings";

export default function InviteButton() {
  const {
    app: {
      project: { id: projectId },
    },
  } = useContext(AppContext);
  const { accountSettings } = useAccountSettings({ projectId });
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [instance, update] = usePDF({
    document: <InstructionPage accountSettings={accountSettings} />,
  });

  React.useEffect(() => {
    update();
  }, [accountSettings])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <ListItemButton
        sx={{
          borderRadius: 1,
          width: "90%",
          margin: "auto",
        }}
        onClick={handleClickOpen}
      >
        <ListItemIcon>
          <Avatar>
            <GroupAddOutlinedIcon />
          </Avatar>
        </ListItemIcon>
        <ListItemText primary={t("navigation.clients.invite")} />
      </ListItemButton>
      {open ? (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="invite-dialog-title"
          aria-describedby="invite-dialog-description"
          maxWidth={"sm"}
          fullWidth
        >
          <DialogTitle id="invite-dialog-title">
            {t("setup.inviteDialog.title")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="invite-dialog-description">
              {t("setup.inviteDialog.text")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="inherit">
              {t("common.actions.close")}
            </Button>
            <Button
              href={instance.url}
              download={`${t("setup.manual.pdfTitle", {
                firstName: accountSettings.firstName,
                lastName: accountSettings.lastName,
              })}.pdf`}
              onClick={handleClose}
              color="primary"
            >
              {t("setup.inviteDialog.download")}
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </div>
  );
}
